import type { StrapiPartner } from "@skv/core";
import { Error404Fragment, ExternalLink } from "@skv/core";
import { useViewModel } from "@skv/state";

export const Partners = () => {
  const [{ data, status }] = useViewModel<StrapiPartner[]>();

  if (status === "loading") {
    return (
      <div className="container mb-5">
        <p>Loading, please wait...</p>
      </div>
    );
  }

  if (!data || status === "error") {
    return (
      <div className="container mb-5">
        <Error404Fragment />
      </div>
    );
  }

  if (data.length === 0) {
    return null;
  }

  return (
    <>
      <h2 className="mb-4">Partners</h2>
      <section className="row">
        {data.map((partner, idx) => (
          <div key={idx} className="col-md-6 mb-3 pb-md-3">
            <article
              className="d-flex flex-column align-items-start p-4"
              css={`
                border: 2px solid ${(p) => p.theme.gray200};
              `}
            >
              <img
                src={partner.logo.url}
                alt={partner.name}
                width={140}
                height={35}
                className="img-fluid mb-4"
              />
              <ExternalLink href={partner.url} className="mb-3">
                {partner.name}
              </ExternalLink>
              <small className="mb-3">{partner.description}</small>
              {!!partner.services.length && (
                <ul className="list-styled list-styled--tick list-styled--success">
                  {partner.services.map((service, idx) => (
                    <li key={idx}>{service}</li>
                  ))}
                </ul>
              )}
            </article>
          </div>
        ))}
      </section>
    </>
  );
};
